import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { RouterModule } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ClipboardModule } from 'ngx-clipboard';
import { MaterialModule } from '../material/material.module';
import { CenterCardComponent } from './components/center-card/center-card.component';
import { FooterComponent } from './components/footer/footer.component';
import { LanguageComponent } from './components/language/language.component';
import { LeftCardComponent } from './components/left-card/left-card.component';
import { LoadImageComponent } from './components/load-image/load-image.component';
import { NavBarComponent } from './components/nav-bar/nav-bar.component';
import { PlanExpiredComponent } from './components/plan-expired/plan-expired.component';
import { RightCardComponent } from './components/right-card/right-card.component';
import { SimpleTableComponent } from './components/simple-table/simple-table.component';
import { DropZoneDirective } from './directives/drop-zone.directive';
import { InputRestrictionDirective } from './directives/input-restriction.directive';
import { UploadMediaDirective } from './directives/upload-media.directive';
import { GalleryCompanyComponent } from './gallery-company/gallery-company.component';
import { GalleryComponent } from './gallery/gallery.component';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
const COMPONENTS = [
  FooterComponent,
  LanguageComponent,
  LoadImageComponent,
  PlanExpiredComponent,
  NavBarComponent,
  CenterCardComponent,
  LeftCardComponent,
  SimpleTableComponent,
  RightCardComponent,
  GalleryComponent,
  GalleryCompanyComponent,
];
const DIRECTIVES = [
  InputRestrictionDirective,
  DropZoneDirective,
  UploadMediaDirective,
];
const PIPES = [SafeUrlPipe];

@NgModule({
  declarations: [COMPONENTS, DIRECTIVES, PIPES],
  imports: [
    RouterModule,
    CommonModule,
    ClipboardModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MaterialModule,
    NgxQRCodeModule,
    TooltipModule.forRoot(),
    CarouselModule.forRoot(),
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => {
          return new TranslateHttpLoader(http);
        },
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    MatNativeDateModule,
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
  ],
  exports: [COMPONENTS, DIRECTIVES, PIPES],
})
export class SharedModule {}
